import React from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Select } from "antd";
import "./log_spareparts.css";
import { HocLogSparepartsTable } from "./hoc_log_spareparts";

const LogSpareparts: React.FC = () => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (
        <div id="ijgf" style={transformStyle}>
            <div className="gjs-grid-row" id="ic7mm">
                <div className="gjs-grid-column" id="isk2t">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                title: "Log Spareparts",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="i5cj2">
                <div className="gjs-grid-column" id="isp7j">
                    <HocLogSparepartsTable />
                </div>
            </div>
        </div>
    );
};

export default LogSpareparts;
